import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { ModalStatusService } from '../../../shared/services/modal-status.service';
import { IDestinationBoxElement } from '../../interfaces/idestination-box-element';
import { IEngineParamChange } from '../../interfaces/iengine-param-change';
import { EngineHolidayModalAirportComponent } from '../engine-holiday-modal-airport/engine-holiday-modal-airport.component';
import { EngineTabTypes } from './../../models/engine-tab-types.enum';

@Component({
  selector: 'app-engine-holiday-control-airport',
  templateUrl: './engine-holiday-control-airport.component.html',
  styleUrls: ['./engine-holiday-control-airport.component.scss']
})
export class EngineHolidayControlAirportComponent implements OnInit, OnChanges, OnDestroy {

  @Input() selectedDestination: IEngineParamChange<IDestinationBoxElement>;
  @Input() onlyCustomHoliday: boolean;
  @Input() onlyNetQuotes: boolean;
  @Input() defaultAirport: (number | string)[];
  @Input() isB2B$: Observable<boolean>;
  @Input() engineTabType: EngineTabTypes;
  @Output() selectedAirport = new EventEmitter<IEngineParamChange<(string | number)[]>>();

  isB2BSubscription: Subscription;
  selectedAirportSubscription: Subscription;
  selectedAirportInner: (number | string)[];
  selectedFirstAirport: number | string;

  private modalRef: NgbModalRef;

  constructor(private _modalService: NgbModal,
              private _modalStatusService: ModalStatusService) {
  }

  open(): void {
    this.defaultAirport = this.selectedAirportInner ? this.selectedAirportInner : undefined;
    if (!this._modalService.hasOpenModals()) {
      this._modalStatusService.hasOpenModals.next(true);
      this.isB2BSubscription = this.isB2B$.subscribe((b) => {
        const isB2B = b;
        this.modalRef = this._modalService.open(EngineHolidayModalAirportComponent, {
          ariaLabelledBy: 'modal-engine',
          size: 'lg'
        });
        this.modalRef.componentInstance.selectedDestination = this.selectedDestination;
        this.modalRef.componentInstance.onlyCustomHoliday = this.onlyCustomHoliday;
        this.modalRef.componentInstance.onlyNetQuotes = this.onlyNetQuotes;
        this.modalRef.componentInstance.defaultAirport = this.defaultAirport;
        this.modalRef.componentInstance.engineTabType = this.engineTabType;
        this.modalRef.componentInstance.isB2B = isB2B;
        this.selectedAirportSubscription = this.modalRef.componentInstance.selectedAirport.subscribe(e => {
          this.selectedAirport.emit(e);
          this.selectedAirportInner = e.value;
          this.selectedFirstAirport = e.value ? e.value[0] : undefined;
        });
        this.modalRef.result.finally(() => this._modalStatusService.hasOpenModals.next(false));
      });
    }
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.isB2BSubscription?.unsubscribe();
    this.selectedAirportSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedDestination && this.selectedDestination) {
      this.selectedAirport.emit({value: undefined, resetParams: false});
      this.selectedAirportInner = undefined;
    }
    if (this.defaultAirport) {
      this.selectedAirport.emit({value: this.defaultAirport, resetParams: false});
      this.selectedAirportInner = JSON.parse(JSON.stringify(this.defaultAirport));
      this.selectedFirstAirport = this.defaultAirport[0];
    }
  }

}
